export const ItemTypes = {
	CARD: 'card',
};



// WEBPACK FOOTER //
// ./src/themes/default/modules/report/pages/ItemTypes.js